<div>
  <app-callout
    ><div
      innerHtml="{{ 'assetPermissions.infoBox.group' | translate: { groupManagementUrl } }}"
    ></div
  ></app-callout>

  <app-group-permissions-add #groupPermissionAdd [narrow]="narrow" (add)="onNewPermission($event)">
  </app-group-permissions-add>

  @if (error) {
    <app-callout
      [severity]="errorSeverity"
      [closable]="true"
      (calloutClosed)="setError(undefined)"
      >{{ error | translate }}</app-callout
    >
  }
</div>

<app-permissions-view
  [isGroupPermission]="true"
  [permissionEntries]="permissionEntries"
  [totalRecords]="totalRecords"
  [pageSize]="PAGE_SIZE"
  [paginatorStart]="paginatorStart"
  [narrow]="narrow"
  [loading]="loading"
  [saving]="saving"
  (deletePermission)="onDeletePermission($event)"
  (togglePermission)="onTogglePermissions($event.entry, $event.permission)"
  (lazyLoad)="onLazyLoad($event)"
></app-permissions-view>
